import Api from './Api';

export default {
    getCampaignTypes() {
        return Api().get('/api/marketingautomation/getcampaigntypes')
    },
    getEmailProviders() {
        return Api().get('/api/marketingautomation/getemailproviders')
    },
    getEmailSenders() {
        return Api().get('/api/marketingautomation/getemailsenders')
    },
    getSegments() {
        return Api().get('/api/marketingautomation/getsegments')
    },
    addCampaign(payload) {
        return Api().post('/api/marketingautomation/addcampaign', payload)
    },
    getCampaigns() {
        return Api().get('/api/marketingautomation/getcampaigns')
    },
    getCampaignDetails(payload) {
        return Api().post('/api/marketingautomation/getcampaigndetails', payload)
    },
    editCampaign(payload) {
        return Api().post('/api/marketingautomation/editcampaign', payload)
    },
    addCampaignBasic(payload) {
        return Api().post('/api/marketingautomation/addcampaignbasic', payload)
    },
    getAddCampaignDetails(payload) {
        return Api().post('/api/marketingautomation/getaddcampaigndetails', payload)
    },
    updateCampaignMessage(payload) {
        return Api().post('/api/marketingautomation/updatecampaignmessage', payload)
    },
    finalAddCampaign(payload) {
        return Api().post('/api/marketingautomation/finaladdcampaign', payload)
    },
    editCampaignBasic(payload) {
        return Api().post('/api/marketingautomation/editcampaignbasic', payload)
    },
    editCampaignMessage(payload) {
        return Api().post('/api/marketingautomation/editcampaignmessage', payload)
    },
    finalEditCampaign(payload) {
        return Api().post('/api/marketingautomation/finaleditcampaign', payload)
    },


    //SMS Campaign

    getSmsCampaigns() {
        return Api().get('/api/marketingautomation/getsmscampaigns')
    },

    getSMSProviders() {
        return Api().get('/api/marketingautomation/getsmsproviders')
    },
    getSMSSenders() {
        return Api().get('/api/marketingautomation/getsmssenders')
    },
    getSegments() {
        return Api().get('/api/marketingautomation/getsegments')
    },
    getAddSmsCampaignDetails(payload) {
        return Api().post('/api/marketingautomation/getaddsmscampaigndetails', payload)
    },
    addSmsCampaignBasic(payload) {
        return Api().post('/api/marketingautomation/addsmscampaignbasic', payload)
    },
    updateSmsCampaignMessage(payload) {
        return Api().post('/api/marketingautomation/updatesmscampaignmessage', payload)
    },
    finalAddSmsCampaign(payload) {
        return Api().post('/api/marketingautomation/finaladdsmscampaign', payload)
    },
    getSmsCampaignDetails(payload) {
        return Api().post('/api/marketingautomation/getsmscampaigndetails', payload)
    },
    editSmsCampaignBasic(payload) {
        return Api().post('/api/marketingautomation/editsmscampaignbasic', payload)
    },
    editSmsCampaignMessage(payload) {
        return Api().post('/api/marketingautomation/editsmscampaignmessage', payload)
    },
    finalEditSmsCampaign(payload) {
        return Api().post('/api/marketingautomation/finaleditsmscampaign', payload)
    },
    GetEmailTemplates() {
        return Api().get("/api/marketingautomation/emailcampaign/emailtemplate");
    },
    AddEmailTemplate(payload) {
        return Api().post("/api/marketingautomation/emailcampaign/emailtemplate", payload);
    },
    GetSmsTemplates() {
        return Api().get("/api/marketingautomation/smscampaign/smstemplate");
    },
    AddSmsTemplate(payload) {
        return Api().post("/api/marketingautomation/smscampaign/smstemplate", payload);
    },
    //SEGMENTS
    GetCustomers(payload) {
        return Api().get(`/api/marketingautomation/segments/getcustomers?limit=${payload.limit}&currentPage=${payload.currentPage}`);
    },
    AddSegment(payload) {
        return Api().post("/api/marketingautomation/segments/addsegment", payload);
    },
    GetSegments() {
        return Api().get("/api/marketingautomation/segments/getsegments");
    },
    GetSingleSegment(payload) {
        return Api().post("/api/marketingautomation/segments/getsinglesegment", payload);
    },
    UpdateSegment(payload) {
        return Api().post("/api/marketingautomation/segments/updatesegment", payload);
    },
    GetFilteredCustomers(payload) {
        return Api().post(`/api/marketingautomation/segments/getfilteredcustomers?limit=${payload.limit}&currentPage=${payload.currentPage}`, payload);
    },
    GetCustomerFlow(payload) {
        return Api().post(`/api/marketingautomation/getcustomerflow/`, payload);
    },
}



// WEBPACK FOOTER //
// ./src/services/MarketingAutomationService.js